<template>
  <main>
    <AppTitle>Новости</AppTitle>

    <Preloader v-if="total < 0"/>
    <template v-else>
      <template v-for="item in news.slice(0, page * count)">
        <section v-if="item.status_id === 'Активна'" :key="item.id">
          <AppSubTitle>
            [{{ item.date }}] {{ item.title }}
          </AppSubTitle>
          <AppText v-html="item.content"/>
        </section>
      </template>

      <AppButton 
        v-if="page * count < total"
        outline
        size="small"
        v-text="'Загрузить еще...'"
        @click="page++"
      />
    </template>
  </main>
</template>


<script>
import AppText from '@/components/game/ui/AppText';
import AppTitle from '@/components/game/ui/AppTitle';
import AppButton from '@/components/game/ui/AppButton';
import AppSubTitle from '@/components/game/ui/AppSubTitle';
import Preloader from '@/components/game/Preloader';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Game_NewsView',

  components: {
    AppText,
    AppTitle,
    AppButton,
    AppSubTitle,
    Preloader,
  },

  data: () => ({
    total: -1,
    count: 10,
    page: 1,
    news: [],
  }),

  computed: {
    ...mapGetters(['token']),
  },

  async mounted() {
    try {
      const headers = {};
      headers.token = this.token;
      const response = await fetch('/api/newsfeed', { headers });
      const { data, total } = await response.json();
      this.total = total;
      this.news = data.map(d => {
        d.date = this.toDate(d.published);
        return d;
      });
    } catch(err) {
      console.error(err);
    };
  },

  methods: {
    toDate(published) {
      const date = new Date(published);
      const day = date.getDate().toString().padStart(2, 0);
      const month = (date.getMonth() + 1).toString().padStart(2, 0);
      const year = date.getFullYear().toString().slice(-2);
      return `${day}.${month}.${year}`;
    },
  },
};
</script>


<style lang="scss" scoped>
main {
  gap: 0 !important;

  & > section {
    color: var(--color-dark);
    line-height: 1.7;

    h2 {
      font-size: 16px;
      margin: 16px 0 8px;
      color: var(--color-secondary);
    }

    p a {
      text-decoration: underline;
      color: inherit;
    }
  }

  & > button {
    margin-top: 1em;
  }
}
</style>
